module.exports = __webpack_public_path__ + "img/pagedetails.650e8fe8.svg";